<div class="background-pattern">
    <div class="content z-10 position-relative">
        <router-outlet></router-outlet>
        <app-back-to-top />
        <p-toast position="top-right" [baseZIndex]="99999"></p-toast>
        <app-update-dialog />
    </div>
    <!-- Outside .z-10 so it can stack above dialogs appended to body -->
    <app-spinner></app-spinner>
</div>